import React from 'react';
import CheckmarkIcon from './check-solid-full.svg';
import styles from './CheckboxMark.module.scss';

function CheckboxMark(props) {
    const { className, checked } = props;

    return <div className={[className, styles.checkbox].join(' ')}>{checked ? <CheckmarkIcon /> : null}</div>;
}

export default CheckboxMark;
